import { PocketBaseClient } from "../PocketbaseClient.js";

export const createDurationMap = (videoData) => {
  const durationMap = {};

  let accDuration = 0;
  for (const video of videoData) {
    durationMap[accDuration] = video.videoId;
    accDuration += video.durationInSeconds || 0;
  }

  return { durationMap, durationInSeconds: accDuration };
};

export async function updatePlaylistDurationMap({ recordName, playlistId }) {
  console.log("Updating playlist duration map - " + playlistId);
  const test = await PocketBaseClient.collection(recordName).getOne(
    playlistId,
    { expand: "songs" }
  );

  const videos = test.expand.songs.map((song) => {
    return test.videoData[song.videoId];
  });

  const { durationMap, durationInSeconds } = createDurationMap(videos);

  await PocketBaseClient.collection(recordName).update(playlistId, {
    durationMap,
    durationInSeconds,
    totalSongs: videos.length,
    requestKey: null,
  });
}
